import { render, staticRenderFns } from "./PinchImage.vue?vue&type=template&id=7e154bc2"
import script from "./PinchImage.vue?vue&type=script&lang=js"
export * from "./PinchImage.vue?vue&type=script&lang=js"
import style0 from "./PinchImage.vue?vue&type=style&index=0&id=7e154bc2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports